import { Text } from '@mantine/core';
import { type CalendarDay } from '../Calendar';
import dayjs from 'dayjs';

interface Props {
  days: CalendarDay[];
  format: string;
  rowHeight: number;
}

export const SidebarLayer = (props: Props) => {
  const { days, format, rowHeight } = props;

  return (
    <div className="flex flex-col">
      <span style={{ height: rowHeight }} />
      {days.map((day, index) => (
        <span
          key={`sidebar-tile-${index}`}
          style={{ height: rowHeight }}
          className="flex items-center justify-end"
        >
          <Text fw={500} size="sm">
            {dayjs(day.date).format(format)}
          </Text>
        </span>
      ))}
    </div>
  );
};
